
// Adding default notification configuration

export interface NotificationConfig {
  enabled: boolean;
  pushEnabled: boolean;
  emailEnabled: boolean;
  smsEnabled: boolean;
  frequency: 'immediate' | 'daily' | 'weekly';
  threshold?: number;
  latenessThreshold?: number;
  // New fields for reminder scheduling
  reminderFrequency?: 'none' | 'daily' | 'weekly';
  escalationLevels?: number; // How many times to escalate before stopping
  currentEscalationLevel?: number; // Current level of escalation
  lastReminderSent?: string; // ISO date string
}

export interface NotificationSettings {
  paymentReminders: NotificationConfig;
  documentExpiry: NotificationConfig;
  attendanceAlerts: NotificationConfig;
  examResults: NotificationConfig;
  programUpdates: NotificationConfig;
}

// Added user routing configuration
export interface UserNotificationRouting {
  userId: string;
  role: string;
  notificationTypes: string[]; // Types of notifications this user should receive
  channels: {
    email: boolean;
    push: boolean;
    sms: boolean;
  };
  contactInfo?: {
    email?: string;
    phone?: string;
  };
}

export const DEFAULT_CONFIG: NotificationConfig = {
  enabled: true,
  pushEnabled: true,
  emailEnabled: false,
  smsEnabled: false,
  frequency: 'immediate',
  threshold: 3,
  latenessThreshold: 4,
  reminderFrequency: 'none',
  escalationLevels: 3,
  currentEscalationLevel: 0
};

export const DEFAULT_SETTINGS: NotificationSettings = {
  paymentReminders: { ...DEFAULT_CONFIG },
  documentExpiry: { ...DEFAULT_CONFIG },
  attendanceAlerts: { ...DEFAULT_CONFIG, threshold: 3, latenessThreshold: 4 },
  examResults: { ...DEFAULT_CONFIG },
  programUpdates: { ...DEFAULT_CONFIG }
};
